<ng-container *appTranslate="let t">
  <p-multiselect
    #multiSelect
    [fluid]="true"
    [inputId]="inputId"
    [options]="types$ | async"
    [disabled]="disabled"
    [showToggleAll]="false"
    [showClear]="true"
    [ngModel]="model"
    (onBlur)="onModelTouched()"
    (onChange)="updateModel($event.value)"
    (onClear)="updateModel(null)"
  />
</ng-container>
